module.exports = __webpack_public_path__ + "img/syt1.766900f6.jpg";